
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/singapore-visa",
      function () {
        return require("private-next-pages/concierge/singapore-visa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/singapore-visa"])
      });
    }
  